import { Matrix4x4 } from "../../../maths/Matrix4x4";
import { Vector3 } from "../../../maths/Vector3";
import { SkyRenderer } from "../../resource/models/SkyRenderer";
import { RenderElement } from "./RenderElement";
const InvertYScaleMat = new Matrix4x4(1, 0, 0, 0, 0, -1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
export class SkyRenderElement extends RenderElement {
    constructor() {
        super();
        this._viewMatrix = new Matrix4x4();
        this._projectionMatrix = new Matrix4x4();
        this._projectViewMatrix = new Matrix4x4();
    }
    calculateViewMatrix(cameraViewMat) {
        cameraViewMat.cloneTo(this._viewMatrix);
        this._viewMatrix.setTranslationVector(Vector3.ZERO);
    }
    caluclateProjectionMatrix(cameraProjMat, aspectRatio, nearPlane, farPlane, fov, orthographic) {
        if (orthographic) {
            let halfWidth = 0.2;
            let halfHeight = halfWidth;
            Matrix4x4.createOrthoOffCenter(-halfWidth, halfWidth, -halfHeight, halfHeight, nearPlane, farPlane, this._projectionMatrix);
        }
        else {
            cameraProjMat.cloneTo(this._projectionMatrix);
            let epsilon = 1e-6;
            let yScale = 1.0 / Math.tan(Math.PI * fov / 180 * 0.5);
            this._projectionMatrix.elements[0] = yScale / aspectRatio;
            this._projectionMatrix.elements[5] = yScale;
            this._projectionMatrix.elements[10] = epsilon - 1.0;
            this._projectionMatrix.elements[11] = -1.0;
            this._projectionMatrix.elements[14] = -0;
        }
    }
    renderpre(context) {
        if (context.invertY) {
            Matrix4x4.multiply(InvertYScaleMat, this._projectionMatrix, Matrix4x4.TEMP);
            Matrix4x4.multiply(Matrix4x4.TEMP, this._viewMatrix, tmpMatrix);
            this._renderElementOBJ.renderShaderData.setMatrix4x4(SkyRenderer.SKYPROJECTIONMATRIX, Matrix4x4.TEMP);
            this._renderElementOBJ.renderShaderData.setMatrix4x4(SkyRenderer.SKYPROJECTIONVIEWMATRIX, tmpMatrix);
        }
        else {
            Matrix4x4.multiply(this._projectionMatrix, this._viewMatrix, this._projectViewMatrix);
            this._renderElementOBJ.renderShaderData.setMatrix4x4(SkyRenderer.SKYPROJECTIONMATRIX, this._projectionMatrix);
            this._renderElementOBJ.renderShaderData.setMatrix4x4(SkyRenderer.SKYPROJECTIONVIEWMATRIX, this._projectViewMatrix);
        }
        this._renderElementOBJ.renderShaderData.setMatrix4x4(SkyRenderer.SKYVIEWMATRIX, this._viewMatrix);
        this._renderElementOBJ.renderShaderData.setColor(SkyRenderer.SUNLIGHTDIRCOLOR, context.scene._sunColor);
        this._renderElementOBJ.renderShaderData.setVector3(SkyRenderer.SUNLIGHTDIRECTION, context.scene._sundir);
    }
}
const tmpMatrix = new Matrix4x4();
